<template>
  <v-card outlined class="app-card" id="areaImpressao">
    <v-card-title class="app-card-title">
      Veículo Pesquisado
      <v-spacer></v-spacer>
      <v-btn text small color="primary" class="no-print" @click="imprimir">
        <v-icon left small>print</v-icon>
        Imprimir
      </v-btn>
    </v-card-title>
    <v-card-text class="app-card-tcontent">
      <!-- cabecalho que so sai no papel -->
      <div class="print-only print-header">
        <h3>Consulta de Pendências — Veículo {{ veiculo.placa }}</h3>
        <p>Emitido em {{ dataEmissao }}</p>
      </div>

      <article class="consulta-pendencias-card">
        <section class="consulta-pendencias-card-content">
          <v-row no-gutters>
            <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 col-info">
              <strong class="info-text">
                Placa:
                <em>{{ veiculo.placa }}</em>
              </strong>
            </v-col>
            <v-col :md="4" :sm="4" :xs="12" cols="12" class="mt-2 col-info">
              <strong class="info-text">
                Ultima vistoria:
                <em>{{ veiculo.ultimaVistoria }}</em>
              </strong>
            </v-col>
            <v-col
              :md="4"
              :sm="4"
              :xs="12"
              cols="12"
              class="mt-2 text-md-right col-info"
            >
              <strong class="info-text">
                Validade vistoria:
                <em>{{ veiculo.validadeVistoria }}</em>
              </strong>
            </v-col>
            <!-- Documentos do veículo -->
            <v-col cols="12" class="mt-4 col-bloco">
              <strong class="info-text">
                <template
                  v-if="
                    veiculo.documentosVeiculo &&
                      veiculo.documentosVeiculo.length > 0
                  "
                >
                  Documentos:
                  <br />
                  <v-alert
                    v-for="(doc, index) in veiculo.documentosVeiculo"
                    :key="index"
                    text
                    outlined
                    dense
                    :color="isVencido(doc.dataValidade) ? 'red' : 'green'"
                  >
                    {{ doc.tipoDocumento }} — Validade:
                    {{ doc.dataValidade || "—" }}
                    <strong v-if="isVencido(doc.dataValidade)">
                      (vencido)</strong
                    >
                  </v-alert>
                </template>
                <template v-else>
                  <v-alert text outlined type="info">
                    O veículo não possui documentos cadastrados
                  </v-alert>
                </template>
              </strong>
            </v-col>

            <!-- Pendências -->
            <v-col :md="6" :sm="6" :xs="12" cols="12" class="mt-2 col-bloco">
              <strong class="info-text">
                <template
                  v-if="
                    veiculo.pendenciaVeiculo &&
                      veiculo.pendenciaVeiculo.length > 0
                  "
                >
                  Pendências:
                  <br />
                  <v-alert
                    v-for="(item, index) in veiculo.pendenciaVeiculo"
                    :key="index"
                    text
                    outlined
                    color="orange"
                  >
                    {{ item.tipoPendencia }}
                  </v-alert>
                </template>
                <template v-else>
                  <v-alert text outlined type="success">
                    O veículo não possui pendências
                  </v-alert>
                </template>
              </strong>
            </v-col>

            <!-- Autos de Infração -->
            <v-col cols="12" class="mt-2 no-print">
              <strong class="info-text">
                Autos de Infração:
                <br />
                <v-btn
                  depressed
                  color="primary"
                  @click="painelMultas = true"
                >
                  Ver autos de infração
                </v-btn>
              </strong>
            </v-col>
          </v-row>
        </section>
      </article>
    </v-card-text>

    <ListaAutosInfracaoPorPlaca
      v-if="painelMultas"
      v-model="painelMultas"
      :placa="veiculo.placa"
    />
  </v-card>
</template>

<script>
import ListaAutosInfracaoPorPlaca from "@/views/transportes/consulta-pendencias/ListaAutosInfracaoPorPlaca";

export default {
  components: {
    ListaAutosInfracaoPorPlaca
  },
  props: {
    veiculo: Object
  },
  data() {
    return {
      painelMultas: false
    };
  },
  computed: {
    dataEmissao() {
      return new Date().toLocaleString("pt-BR");
    }
  },
  methods: {
    // documento vencido = data de validade anterior ao dia de hoje
    isVencido(dataValidade) {
      if (!dataValidade) {
        return false;
      }
      const partes = String(dataValidade).split("/");
      if (partes.length !== 3) {
        return false;
      }
      const validade = new Date(+partes[2], +partes[1] - 1, +partes[0]);
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      return validade < hoje;
    },
    imprimir() {
      window.print();
    }
  },
  mounted() {
    // as regras de @media print deste componente sao globais (o <style> nao
    // é scoped). esta classe garante que elas so valham enquanto o card esta
    // na tela, sem afetar a impressao de outras telas do sistema
    document.body.classList.add("print-pendencias");
  },
  beforeDestroy() {
    document.body.classList.remove("print-pendencias");
  }
};
</script>

<style lang="scss" scoped>
.print-only {
  display: none;
}
</style>

<!-- nao pode ser scoped: precisa alcancar o resto da pagina para escondê-la -->
<style lang="scss">
@media print {
  @page {
    size: A4 portrait;
    margin: 1.2cm;
  }

  // ATENCAO: este <style> nao é scoped, entao as regras sao globais. Por
  // isso tudo fica sob body.print-pendencias — classe que o componente
  // adiciona no mounted e remove no beforeDestroy. Assim a impressao so é
  // afetada enquanto o card de resultado esta na tela; outras telas do
  // sistema imprimem normalmente.
  body.print-pendencias {
    height: auto !important;
    overflow: visible !important;
    background: #fff !important;

    // esconde a pagina toda; o card volta a aparecer nas regras abaixo
    * {
      visibility: hidden;
    }

    // 1) o wrapper do vuetify tem min-height 100vh: sem zerar, sobra
    //    espaco fantasma que gera pagina em branco
    // 2) esses containers sao posicionados e tem padding (espaco do menu
    //    lateral): enquanto forem o ancestral posicionado, o "left: 0" do
    //    card vale a partir DELES, e nao da folha. Estaticos, o card
    //    ancora na propria pagina
    .v-application,
    .v-application--wrap,
    .v-main,
    .v-main__wrap,
    .v-content,
    .v-content__wrap,
    .v-container,
    .container,
    .app-transporte {
      position: static !important;
      min-height: 0 !important;
      height: 0 !important;
      overflow: hidden !important;
      display: block !important;
      margin: 0 !important;
      padding: 0 !important;
      width: auto !important;
      max-width: none !important;
    }

    #areaImpressao {
      visibility: visible;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      margin: 0 !important;
      padding: 0 !important;
      border: none !important;
      box-shadow: none !important;
      font-size: 12px;
      // sem isso o navegador descarta as cores dos v-alert
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;

      * {
        visibility: visible;
      }

      .no-print {
        display: none !important;
      }

      .print-only {
        display: block !important;
      }

      // na folha o viewport é a largura do papel, entao os breakpoints do
      // vuetify (sm/md) caem num valor imprevisivel: fixamos o layout aqui
      .row {
        display: flex !important;
        flex-wrap: wrap !important;
        margin: 0 !important;
      }

      .col-info {
        flex: 0 0 33.3333% !important;
        max-width: 33.3333% !important;
        text-align: left !important;
        padding: 2px 8px 2px 0 !important;
      }

      .col-bloco {
        flex: 0 0 100% !important;
        max-width: 100% !important;
        padding: 0 !important;
      }

      // nao deixa um alerta ser partido entre duas paginas
      .v-alert,
      .col-info,
      .col-bloco {
        page-break-inside: avoid;
        break-inside: avoid;
      }

      .v-card__text {
        padding: 0 !important;
      }

      .app-card-title {
        font-size: 14px;
        padding: 0 0 4px 0 !important;
      }

      .info-text {
        font-size: 12px;
      }

      .v-alert {
        font-size: 11px;
        padding: 6px 10px;
        margin-bottom: 6px;
      }

      .print-header {
        margin-bottom: 12px;
        border-bottom: 1px solid #999;

        h3 {
          font-size: 15px;
          margin-bottom: 2px;
        }

        p {
          font-size: 11px;
          color: #555;
        }
      }
    }
  }
}
</style>
